export const buildContacts = contacts => contacts.map(contact => buildContact(contact));

const buildContact = contact => ({
    ...contact,
    displayName: `${contact.name} ${contact.lastName}`
});

export const buildUsersInContact = user => {
    return ({
        ...user,
        displayName: `${user.name} ${user.last_name}`,
        lastName: user.last_name,
        identifier: user.legal_id
    });
}
